import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { APP_CONFIG } from '@core-app/app.config';
import { BlockAbstractComponent } from '@gallaghercp/core-frontend';

@Component({
  selector: 'core-coro-cta-card-opt1',
  templateUrl: './coro-cta-card-opt2.component.html',
  styleUrl: './coro-cta-card-opt2.component.scss',
  standalone: false,
  encapsulation: ViewEncapsulation.None,
})
export class CoroCtaCardOpt2Component extends BlockAbstractComponent implements OnInit {
  imageUrl!: string;

  override ngOnInit(): void {
    super.ngOnInit();

    if (this.block.data.image_url) {
      this.imageUrl = APP_CONFIG.frontend + this.block.data.image_url;
    }
  }

  get buttonData(): any | null {
    if (!this.block?.data?.button || !this.block?.data?.buttonText) {
      return null;
    }

    return {
      ...this.block.data.button,
      text: this.block.data.buttonText, // Override with translated text
    };
  }
}
